import client from './client';

export const sentryApi = {
  /**
   * Get cached Sentry data for all integrations on a project.
   */
  async getProjectData(projectKey) {
    const { data } = await client.get(`/api/projects/${projectKey}/sentry`);
    return data;
  },

  /**
   * Force refresh Sentry cache for a specific integration.
   */
  async refreshIntegration(projectKey, integrationId) {
    const { data } = await client.get(
      `/api/projects/${projectKey}/sentry/${integrationId}/refresh`
    );
    return data;
  },

  /**
   * Get aggregated Sentry summary for dashboard card.
   */
  async getSummary() {
    const { data } = await client.get('/api/profile/sentry-summary');
    return data;
  },
};
